import { bootstrapApplication } from '@angular/platform-browser';
import { defineCustomElements } from '@trimble-oss/moduswebcomponents/loader';
import { appConfig } from './app/app.config';
import { App } from './app/app';

defineCustomElements(window, { syncQueue: true });

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
